var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("vue-cookie-accept-decline", {
    ref: "myPanel1",
    attrs: {
      debug: false,
      "disable-decline": false,
      "show-postpone-button": false,
      "element-id": "myPanel1",
      position: "bottom-left",
      "transition-name": "slideFromBottom",
      type: "floating",
    },
    on: {
      "clicked-accept": function ($event) {
        return _vm.$emit("cookie-clicked-accept")
      },
      "clicked-decline": function ($event) {
        return _vm.$emit("cookie-clicked-decline")
      },
      "clicked-postpone": function ($event) {
        return _vm.$emit("cookie-clicked-postpone")
      },
      "removed-cookie": _vm.cookieRemovedCookie,
    },
    scopedSlots: _vm._u([
      {
        key: "message",
        fn: function () {
          return [
            _vm._v(" " + _vm._s(_vm.T.modalConsentCookiesDescription) + " "),
          ]
        },
        proxy: true,
      },
      {
        key: "declineContent",
        fn: function () {
          return [_vm._v(_vm._s(_vm.T.modalConsentCookiesDecline))]
        },
        proxy: true,
      },
      {
        key: "acceptContent",
        fn: function () {
          return [_vm._v(_vm._s(_vm.T.modalConsentCookiesAccept))]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }